import(/* webpackMode: "eager" */ "/app/app/[locale]/privacy-policy/page.tsx");
